import { useEffectOnce } from 'react-use';

/** Auto-scrolls to top of the page when first rendered */
export const useAutoScrollToTop = () => {
  useEffectOnce(() => {
    setTimeout(() => {
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: 'instant',
      });
    }, 0);
  });
};
